import Request from "../lib/httprequest.js";
const GET_VOTE_ITEMS = "/vote/getVoteItems"; //获取投票列表
const SAVE_VOTE_IOFO = "/vote/saveVoteInfo"; //投票确认保存
const GET_OPENID_BYCODE = "/wechat/getOpenIdByCode"; //根据微信code获取微信openId
const GET_SHARE_NEEDS_PARAM = "/vote/wechat/getShareNeedsParam"; //投票确认保存
const GET_OAUTH_APP_ID = "/vote/wechat/getOauthAppId"; //静默授权根据code获取openID
const GET_ACCESS_TOKEN_BY_CODE = "/wechat/getAccessTokenByCode"; //静默授权根据code获取openID和accessToken
const GET_WX_USER_INFO = "/wechat/getWxUserInfo"; //静默授权获取微信昵称和头像
const DHGOODS_INFO_LIST = "/dhGoodsInfo/list"; //当前可抢购商品列表
const SECKILL_RESTTIME = "/secKill/restTime"; //商品剩余时间获取
const SECKILL_KILL = "/secKill/kill"; //抢购（秒杀）商品
const DHGOODS_INFO_DETAIL = "/dhGoodsInfo/detail"; //抢购商品详情
const GET_MEMBER_BYID = "/member/getMemberById"; //根据会员ID获取会员对象
const DHRECORD_LIST = "/dhRecord/list"; //会员兑换记录
const WRITE_OFF = "/dhRecord/writeOff"; //用户自主核销
const COUPON_LIST = "/coupon/list"; //当前可抢购消费券列表
const COUPON_DETAIL = "/coupon/detail"; //消费券抢购详情接口
const GET_SUCCESS_COUPON_LIST = "/coupon/getSuccessCouponList"; //已抢购成功的消费券列表
const SECKILL_COUPONKILL = "/secKill/couponKill"; //抢购（秒杀）优惠券
const IS_WRITEOFF = "/coupon/isWriteOff"; //消费券是否核销过
const COUPON_RESTTIME = "/secKill/couponRestTime"; //优惠券剩余时间获取
const NEW_TIME_LIST = "/jstv/getNewTimeList"; //获取新征程专题下的文章列表
// 报名活动cba
const SIGNUPACTIVITY_LIST = "/signUpActivity/list"; //获取当前参与项目的列表
const SIGNUPACTIVITY_DETAIL = "/signUpActivity/detail"; //获取当前参与项目详情
const SIGNUPKILL = "/secKill/signUpKill"; //获取当前参与项目的列表
const GETWINNINGRECORD = "/signUpActivity/getWinningRecord"; //获取中奖记录

// 预约排号
const GETAPPOINTRECORDLIST = "/appointGovInfo/getAppointRecordList"; //用户获取政务预约记录

//房产税预约模块
const GET_REAL_NAME_BY_MEMBER_ID = "/appointGovInfo/getRealNameByMemberId"//根据会员ID获取会员信息。

const POST_REAL_NAME_AUTH = "/appointGovInfo/realNameAuth"//提交实名认证。
const GET_APPOINT_GOV_DEPART_LIST = "/appointGovInfo/getAppointGovDepartList"//获取可预约部门列表
const GET_APPOINT_GOV_ITEM_LIST = "/appointGovInfo/getAppointGovItemList" //获取可预约项目
const GET_APPOINT_DETAIL_LIST = "/appointGovInfo/getAppointDetailList"//获取预约时间段与预约状态
const GET_APPOINT_GOV_INFO = "/appointGovInfo/getAppointGovInfo"//获取预约首页初始化数据
const SUBMIT_DATE_APPOINT = "/govSecKill/kill"//执行预约方法

const RECOVERKILL = "/govSecKill/recoverKill"//取消预约方法

const REST_TIME_OF_SEC_KILL = "/govSecKill/restTime"//获取距离秒杀的剩余时间
const GET_BASKET_COMMENT_LIST = "/basket/getBasketCommentList"
const GET_TOTAL_COMMENT_LIST = "/basket/getTotalCommentList"
const GET_TOTAL_SCORE_INFO = "/basket/getTotalScoreInfo"
const SEND_BASKET_COMMENT = "/basket/sendBasketComment"
const EXCHANGE_GIFT = "/basket/exchangeGift"
const EXCHANGE_LIST = "/basket/exchangeList"
const EXCHANGE_WRITE_OFF = "/basket/exchangeWriteOff"
const GET_EXCHANGE_SCORE_INFO = "/basket/getexchangeScoreInfo"
const CLICK_FAVOR = "/basket/clickFavor"
const ANSWER_COMMENT = "/basket/answerComment"
const ANSWER_COMMENT_LIST = "/basket/answerCommentList"
const GET_TOTAL_ANSWER_COMMENT_LIST = "/basket/getTotalAnswerCommentList"
const GET_REAL_USER = "/basket/getRealUser"
const SUBMIT_REAL_USER = "/basket/submitRealUser"
const GET_SING = "/basket/getSing"
const EXPOSURE_LIST = "/feedback/exposureList"
const EXPOSURE_SAVE = "/feedback/exposureSave"
const EXPOSURE_ANSWER = "/feedback/exposureAnswer"
const GET_EXPOSURE = "/feedback/getExposure"
const CREATE_NUMBER = "/coupon/createNumber"
const BOOK_NUMBER_EXCHANGE = "/coupon/bookNumberExchange"
const BOOKSHOP_CARD_LIST = "/coupon/bookShopCardList"
const IS_BOOK_SHOP_WRITEOFF = "/coupon/isBookShopWriteOff"
const OUR_HOLIDAY_TAB_LIST = "/jstv/getOurHolidayTabList"
const OUR_HOLIDAY_LIST = "/jstv/getOurHolidayList"
const SCORE_RANKING_LIST = "/scoreRanking/list"
const SCORE_SUBMIT = "/scoreRanking/scoreSubmit"
const SCORE_SUBMIT_GET_LOSE = "/scoreRanking/scoreSubmitGetLost"
const IS_WRITE_OFF_FLAG = "/coupon/isWriteOffFlag"
const GET_WRITE_OFF_NUM = "/coupon/getWriteOffNum"

const api = {
    getTaxRecoverKill: (option) => {
        option.url = RECOVERKILL
        Request.postNoToken(option)
    },
    getAppointRecordList: (option) => {
        option.url = GETAPPOINTRECORDLIST
        Request.postNoToken(option)
    },
    getSignUpActivityList: (option) => {
        option.url = SIGNUPACTIVITY_LIST
        Request.postNoToken(option)
    },
    getSignUpActivityDetail: (option) => {
        option.url = SIGNUPACTIVITY_DETAIL
        Request.postNoToken(option)
    },
    getSignUpKill: (option) => {
        option.url = SIGNUPKILL
        Request.postNoToken(option)
    },
    getWinningRecord: (option) => {
        option.url = GETWINNINGRECORD
        Request.postNoToken(option)
    },

    getCouponRestTime: (option) => {
        option.url = COUPON_RESTTIME
        Request.postNoToken(option)
    },
    isWriteOff: (option) => {
        option.url = IS_WRITEOFF
        Request.postNoToken(option)
    },
    getSuccessCouponList: (option) => {
        option.url = GET_SUCCESS_COUPON_LIST
        Request.postNoToken(option)
    },
    getCouponKill: (option) => {
        option.url = SECKILL_COUPONKILL
        Request.postNoToken(option)
    },
    getCouponDetail: (option) => {
        option.url = COUPON_DETAIL
        Request.postNoToken(option)
    },
    getCouponList: (option) => {
        option.url = COUPON_LIST
        Request.postNoToken(option)
    },
    getWriteOff: (option) => {
        option.url = WRITE_OFF
        Request.postNoToken(option)
    },
    getDhrecordList: (option) => {
        option.url = DHRECORD_LIST
        Request.postNoToken(option)
    },
    getMemberById: (option) => {
        option.url = GET_MEMBER_BYID
        Request.postNoToken(option)
    },
    getSecKillKill: (option) => {
        option.url = SECKILL_KILL
        Request.postNoToken(option)
    },
    getSecKillRestTime: (option) => {
        option.url = SECKILL_RESTTIME
        Request.postNoToken(option)
    },
    getDhGoodsInfoList: (option) => {
        option.url = DHGOODS_INFO_LIST
        Request.postNoToken(option)
    },
    getDhGoodsInfoDetail: (option) => {
        option.url = DHGOODS_INFO_DETAIL
        Request.postNoToken(option)
    },
    getVoteItems: (option) => {
        option.url = GET_VOTE_ITEMS
        Request.postNoToken(option)
    },
    saveVoteInfo: (option) => {
        option.url = SAVE_VOTE_IOFO
        Request.postNoToken(option)
    },
    getOpenIdByCode: (option) => {
        option.url = GET_OPENID_BYCODE
        Request.post(option)
    },
    getShareNeedsParam: (option) => {
        option.url = GET_SHARE_NEEDS_PARAM
        Request.postNoToken(option)
    },
    getOauthAppId: (option) => {
        option.url = GET_OAUTH_APP_ID
        Request.postNoToken(option)
    },
    getAccessTokenByCode: (option) => {
        option.url = GET_ACCESS_TOKEN_BY_CODE
        Request.postNoToken(option)
    },
    getWxUserInfo: (option) => {
        option.url = GET_WX_USER_INFO
        Request.postNoToken(option)
    },
    getNewTimeList: (option) => {
        option.url = NEW_TIME_LIST
        Request.postNoToken(option)
    },
    getRealNameByMemberId: (option) => {
        option.url = GET_REAL_NAME_BY_MEMBER_ID
        Request.postNoToken(option)
    },
    postRealNameAuth: (option) => {
        option.url = POST_REAL_NAME_AUTH
        Request.postNoToken(option)
    },
    getAppointGovDepartList: (option) => {
        option.url = GET_APPOINT_GOV_DEPART_LIST
        Request.postNoToken(option)
    },
    getAppointGovItemList: (option) => {
        option.url = GET_APPOINT_GOV_ITEM_LIST
        Request.postNoToken(option)
    },
    getAppointDetailList: (option) => {
        option.url = GET_APPOINT_DETAIL_LIST
        Request.postNoToken(option)
    },
    getAppointGovInfo: (option) => {
        option.url = GET_APPOINT_GOV_INFO
        Request.postNoToken(option)
    },
    submitDateAppoint: (option) => {
        option.url = SUBMIT_DATE_APPOINT
        Request.postNoToken(option)
    },
    getRestTimeOfSecKill: (option) => {
        option.url = REST_TIME_OF_SEC_KILL
        Request.postNoToken(option)
    },
    getExposureList: (option) => {
        option.url = EXPOSURE_LIST
        Request.postNoToken(option)
    },
    exposureSave: (option) => {
        option.url = EXPOSURE_SAVE
        Request.postNoToken(option)
    },
    getExposureAnswer: (option) => {
        option.url = EXPOSURE_ANSWER
        Request.postNoToken(option)
    },
    getExposure: (option) => {
        option.url = GET_EXPOSURE
        Request.postNoToken(option)
    },
    getBasketCommentList: (option) => {
        option.url = GET_BASKET_COMMENT_LIST
        Request.postNoToken(option)
    },
    getTotalCommentList: (option) => {
        option.url = GET_TOTAL_COMMENT_LIST
        Request.postNoToken(option)
    },
    getTotalScoreInfo: (option) => {
        option.url = GET_TOTAL_SCORE_INFO
        Request.postNoToken(option)
    },
    sendBasketComment: (option) => {
        option.url = SEND_BASKET_COMMENT
        Request.postNoToken(option)
    },
    exchangeGift: (option) => {
        option.url = EXCHANGE_GIFT
        Request.postNoToken(option)
    },
    getExchangeList: (option) => {
        option.url = EXCHANGE_LIST
        Request.postNoToken(option)
    },
    exchangeWriteOff: (option) => {
        option.url = EXCHANGE_WRITE_OFF
        Request.postNoToken(option)
    },
    getexchangeScoreInfo: (option) => {
        option.url = GET_EXCHANGE_SCORE_INFO
        Request.postNoToken(option)
    },
    clickFavor: (option) => {
        option.url = CLICK_FAVOR
        Request.postNoToken(option)
    },
    answerComment: (option) => {
        option.url = ANSWER_COMMENT
        Request.postNoToken(option)
    },
    answerCommentList: (option) => {
        option.url = ANSWER_COMMENT_LIST
        Request.postNoToken(option)
    },
    getTotalAnswerCommentList: (option) => {
        option.url = GET_TOTAL_ANSWER_COMMENT_LIST
        Request.postNoToken(option)
    },
    getRealUser: (option) => {
        option.url = GET_REAL_USER
        Request.postNoToken(option)
    },
    submitRealUser: (option) => {
        option.url = SUBMIT_REAL_USER
        Request.postNoToken(option)
    },
    getSing: (option) => {
        option.url = GET_SING
        Request.postNoToken(option)
    },
    createNumber: (option) => {
        option.url = CREATE_NUMBER
        Request.postNoToken(option)
    },
    bookNumberExchange: (option) => {
        option.url = BOOK_NUMBER_EXCHANGE
        Request.postNoToken(option)
    },
    getBookShopCardList: (option) => {
        option.url = BOOKSHOP_CARD_LIST
        Request.postNoToken(option)
    },
    isBookShopWriteOff: (option) => {
        option.url = IS_BOOK_SHOP_WRITEOFF
        Request.postNoToken(option)
    },
    getOurHolidayTabList: (option) => {
        option.url = OUR_HOLIDAY_TAB_LIST
        Request.postNoToken(option)
    },
    getOurHolidayList: (option) => {
        option.url = OUR_HOLIDAY_LIST
        Request.postNoToken(option)
    },
    getScoreRankingList: (option) => {
        option.url = SCORE_RANKING_LIST
        Request.postNoToken(option)
    },
    submitTeamScore: (option) => {
        option.url = SCORE_SUBMIT
        Request.postNoToken(option)
    },
    submitTeamGetLose: (option) => {
        option.url = SCORE_SUBMIT_GET_LOSE
        Request.postNoToken(option)
    },
    isWriteOffFlag: (option) => {
        option.url = IS_WRITE_OFF_FLAG
        Request.postNoToken(option)
    },
    getWriteOffNum: (option) => {
        option.url = GET_WRITE_OFF_NUM
        Request.postNoToken(option)
    },
    deepseekAns: (option) => {
        option.url = DEEPSEEK_ANSWER
        Request.postNoToken(option)
    }
};
api.createOption = Request.crateOption;

export default api;